import gql from 'graphql-tag';

export const GetContentAgeQueryGraphql = gql`
	query GetContentAgeQuery($contentId: ID!) {
		content(id: $contentId, status: ["current", "draft"]) {
			nodes {
				id
				history {
					createdDate
				}
				version {
					when
				}
			}
		}
	}
`;
